<template>

<div>
    <button class="auth-action-link" type="button" v-b-modal.modal-center>
        <span>Don't have an account?</span>
        <strong>Register now</strong>
    </button>

    <b-modal id="modal-center" hide-header hide-footer centered>

        <b-alert v-model="showError" variant="danger">{{ errorMessage }}</b-alert>

        <section class="modal-form text-center">
            <span class="brand-kicker">New player</span>
            <h1>Register</h1>
            <form @submit.prevent="register" class="form-grid">
                <div class="form-group">
                    <input required v-model="username" type="email" placeholder="user@example.com" class="form-control">
                </div>
                <div class="form-group">
                    <input required v-model="password" type="password" placeholder="password" class="form-control">
                </div>
                <div class="form-group">
                    <input required v-model="inviteCode" type="text" placeholder="invite code" class="form-control" minlength="2">
                </div>
                <div class="form-group">
                    <input required v-model="firstname" type="text" placeholder="first name" class="form-control" minlength="2">
                </div>
                <div class="form-group">
                    <select v-model="gender" class="form-control form-select" name="gender" required>
                        <option value="M" selected>Male</option>
                        <option value="F">Female</option>
                        <option value="O">Other</option>
                    </select>
                </div>
                <div class="form-group">
                    <input v-model="birthdate" class="form-control" type="date" required>
                </div>
                <div class="terms-row">
                    <div>
                        <input class="form-check-input" type="checkbox" value="" required>
                    </div>
                    <label class="form-check-label">
                        I accept the <a href="https://microtaur.com/terms-of-service-ig" target="_blank">Terms of Use</a> and <a href="https://microtaur.com/privacy-policy-ig" target="_blank">Privacy Policy</a> of the service.
                    </label>
                </div>
                <button type="submit" class="btn btn-primary btn-lg w-100">Create account</button>
            </form>
        </section>

    </b-modal>
</div>

</template>

<script>
import AuthService from '@/services/auth.service.js'
import { BModal, VBModal } from "bootstrap-vue";

export default {
    name: 'RegisterForm',
    components: {
        BModal,
    },
    directives: {
        'b-modal': VBModal
    },
    data () {
        return {
            username: null,
            password: null,
            firstname: null,
            gender: 'M',
            birthdate: null,
            inviteCode: null,

            showError: false,
            errorMessage: "Internal error",
        }
    },
    methods: {
        register() {
            AuthService.register(
                {
                    email: this.username,
                    password: this.password,
                    firstname: this.firstname,
                    gender: this.gender,
                    birthdate: this.birthdate,
                    invite_code: this.inviteCode,
                }
            )
            .then(response => onRegisterSuccess(this, response))
            .catch(error => onRegisterFailed(this, error));
        }
    }
}


function onRegisterSuccess(context) {
    context.$root.$emit('bv::hide::modal', 'modal-center');
    context.$parent.$emit('register-success');
}


function onRegisterFailed(context, error) {
    if ('password' in error.response.data) {
        context.errorMessage = "Password does not meet requirements: must contain at least one lowercase character, one numeric character, and can't be shorter than 6 characters.";
    }
    else if ('email' in error.response.data) {
        if (error.response.data['email'].find(s => s.includes("exists"))) {
            context.errorMessage = "User already exists!";
        } else {
            context.errorMessage = "Provided email address is incorrect";
        }
    }
    else if ('birthdate' in error.response.data) {
        if (error.response.data['birthdate'].find(s => s.includes("too young"))) {
            context.errorMessage = "You must be 18 years old in order to register.";
        }
        if (error.response.data['birthdate'].find(s => s.includes("too old"))) {
            context.errorMessage = "Incorrect birthdate provided.";
        }
    }
    else if ('invite_code' in error.response.data) {
        if (error.response.data['invite_code'].find(s => s.includes("Incorrect"))) {
            context.errorMessage = "Provided invite code is incorrect.";
        }
    }
    else {
        console.log(error.response);
    }

    context.showError = true;
}


</script>

<style>
.auth-action-link {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    border: 0;
    border-radius: 8px;
    padding: 0.75rem 0.85rem;
    background: rgba(248, 255, 47, 0.28);
    color: var(--ss-ink);
    text-align: left;
    font: inherit;
}

.auth-action-link span {
    color: var(--ss-muted);
    font-size: 0.92rem;
    font-weight: 800;
}

.auth-action-link strong {
    white-space: nowrap;
    font-weight: 950;
}

.modal-form {
    padding: 0.75rem;
}

.modal-form h1 {
    margin-bottom: 1rem;
    font-size: 2.5rem;
}

.form-grid {
    display: grid;
    gap: 0.75rem;
}

.terms-row {
    display: grid;
    grid-template-columns: 1.25rem 1fr;
    gap: 0.75rem;
    margin: 0.5rem 0;
    text-align: left;
    color: var(--ss-muted);
    font-size: 0.9rem;
    font-weight: 700;
}

.form-check-input {
    border: 2px solid var(--ss-line);
}
</style>
